<template>
  <div>
    <div
      id="notifications"
      class="z-50 leading-normal text-gray-600"
    >
      <div class="overflow-hidden border border-b-0 bg-white shadow-lg md:rounded-lg">
        <div
          class="border-b p-2 px-3 tracking-wide"
          style="
            background: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(240, 240, 240, 1));
          "
        >
          Notifications
        </div>

        <div
          v-if="initialLoad"
          class="w-full min-w-full p-4 text-center"
        >
          <LoadingSpinner class="mx-auto" />
        </div>

        <div
          v-else
          id="notificationList"
          class="overflow-y-scroll"
          style="max-height: 340px"
          @scroll.passive="scrollEvent"
        >
          <NotificationItem
            v-for="notification in filteredList"
            :key="notification.id"
            :notification="notification"
            @click="closeNotificationMenu()"
          />
          <div
            v-if="filteredList.length === 0"
            class="p-3 text-center text-gray-500"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="bell"
              role="img"
              viewBox="0 0 448 512"
              class="mx-auto h-12 w-12"
            >
              <path
                fill="currentColor"
                d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
              />
            </svg>
            <h3 class="mt-2 text-sm font-medium text-gray-900">
              No notifications
            </h3>
          </div>
          <div
            v-if="!endOfList && filteredList.length > 0"
            class="w-full min-w-full bg-gray-100 text-center"
          >
            <LoadingSpinner class="mx-auto my-2" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { services } from '../../services';
import NotificationItem from './notificationItem.vue';
import LoadingSpinner from '../base/loadingSpinner.vue';

export default {
  components: {
    LoadingSpinner,
    NotificationItem,
  },

  data() {
    return {
      initialLoad: true,
      loading: false,
      index: 0,
      endOfList: false,
      notifications: null,
      menu: null,
    };
  },

  computed: {
    filteredList() {
      return this.$isNine ? this.notifications.filter(n => n.type !== 1) : this.notifications;
    },
  },

  mounted() {
    this.getNotifications();
  },

  methods: {
    getNotifications() {
      services.notification.notifications(this.index).then((data) => {
        if (this.notifications === null) {
          this.notifications = data;
        } else {
          data.forEach(not => this.notifications.push(not));
        }

        if (data.length < 15) {
          this.endOfList = true;
        }

        if (this.initialLoad) {
          this.initialLoad = false;
          setTimeout(() => {
            this.menu = document.getElementById('notificationList');
          }, 500);
        } else {
          this.loading = false;
        }
      });
    },

    scrollEvent() {
      if (!this.loading && !this.endOfList) {
        if (this.menu.scrollHeight - this.menu.scrollTop - 25 < this.menu.clientHeight) {
          this.loading = true;
          this.index += 1;
          this.getNotifications();
        }
      }
    },

    closeNotificationMenu() {
      this.$emit('close', false);
    },
  },
};
</script>

<style>
/* width */
#notifications ::-webkit-scrollbar {
  width: 5px;
}

/* Track */
#notifications ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
#notifications ::-webkit-scrollbar-thumb {
  background-color: #999;
}

/* Handle on hover */
#notifications ::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

@media (min-width: 768px) {
  #notifications {
    position: absolute;
    top: 35px;
    right: -38px;
    width: 380px;
  }

  #notifications:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    color: transparent;
    border: 10px solid rgb(0, 0, 0);
    border-color: transparent transparent #e2e8f0;
    margin-left: 312px;
    margin-top: -5px;
  }
}

@media (max-width: 768px) {
  #notifications {
    position: fixed;
    top: 47px;
    left: 0px;
    width: 100vw;
  }

  #notifications:before {
    content: '';
    display: block;
    width: 0;
    height: 0;
    color: transparent;
    border: 10px solid rgb(0, 0, 0);
    border-color: transparent transparent transparent;
    margin-left: 239px;
    margin-top: -5px;
  }
}
</style>
